import { useAppSelector } from 'src/app/reduxCustomHooks';
import type { DemoAuthUser } from './useDemoAuthBootstrap';

export type DemoFirstUploadTrim = { usedPages: number; totalPages: number };

/**
 * Set when the demo's first upload had more pages than the demo allows and
 * the backend used only the first pages. Page counts only.
 */
export const useDemoFirstUploadTrim = (): DemoFirstUploadTrim | null =>
  useAppSelector((state) => {
    const trim = (state.auth.user as DemoAuthUser | null)?.demo
      ?.firstUploadTrim;
    if (
      !trim ||
      !Number.isFinite(trim.usedPages) ||
      !Number.isFinite(trim.totalPages) ||
      trim.totalPages <= trim.usedPages
    ) {
      return null;
    }
    return trim;
  });
